import { render, staticRenderFns } from "./assays-view-batch-modal-protocols.vue?vue&type=template&id=e2c70d9a&scoped=true&"
import script from "./assays-view-batch-modal-protocols.ts?vue&type=script&lang=ts&"
export * from "./assays-view-batch-modal-protocols.ts?vue&type=script&lang=ts&"
import style0 from "./assays-view-batch-modal-protocols.scss?vue&type=style&index=0&id=e2c70d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c70d9a",
  null
  
)

export default component.exports